module.exports = __webpack_public_path__ + "img/9788967351274.c1ca3b6a.jpg";